import CourseAPI from '@/apis/business/MISAStore/course-api.js'
import enumeration from '@/common/enumeration'
import PracticeCourseAPI from '@/apis/business/student/practice-course-api.js'
import StudentCartAPI from '@/apis/business/student/student-cart-api.js'
import ELKCourseAPI from '@/apis/business/MISAStore/elk-course-api.js'
import CartRegistrationFromAPI from '@/apis/business/student/cart-registration-form-api.js'
import { HttpStatusCode } from '@/common/constant'
import { Data } from '@/common/common-data/index.js'

const defaultGrade = -1
export default {
  namespaced: true,
  state: {
    // Danh sách học liệu của học mãi
    listCourses: [],
    exerciseLibrary: { // Tham số cho query filter
      GradeID: defaultGrade, // Khối
      SubjectID: '', // Môn
      TakeCharge: enumeration.TakeCharge.All, // Miễn phí/mất phí
      Status: null, // Trạng thái : Đã học, chưa học, đang học
      queryText: '' // Text tìm kiếm
    },
    learningTabFilter: { // Tham số cho query filter tab đang học
      subjectID: '', // Môn
      queryText: '' // Text tìm kiếm
    },
    careTabFilter: { // Tham số cho query filter tab quan tâm, màn hình học liệu của bạn
      myCourseStatus: enumeration.MyCourseStatus.NotYet, // Môn
      subjectID: '', // Môn
      queryText: '' // Text tìm kiếm
    },
    FavouriteTabFilter: { // Tham số cho query filter tab quan tâm, màn hình học liệu yêu thích
      SubjectID: '', // Môn
      queryText: '' // Text tìm kiếm
    },
    sourceId: enumeration.SourceTypeCourse.All,
    sourceLibraryId: enumeration.LibraryCourseType.All,
    totalExerciseHOCMAI: 0,
    course: {},
    coursesRefer: [],
    videoIntro: {},
    appendLearningExercisesOld: [],
    appendLearningExercises: [],
    totalLearningExercises: 0,
    totalCareExercises: 0,
    appendCareExercisesOld: [],
    appendCareExercises: [],
    isShowUseNow: true,
    isShowCourseOverview: true, // đánh dấu hiển thị màn hình overview có cả thumbnail
    // TODO đây là phần state của exercise reference
    totalExerciseRef: null, // Tổng số bài tập từ kho ex reference
    libraryLearningExercises: [],
    totalLearningExercise: 0,
    libraryExercisesRef: [], // Bài tập từ kho  ex reference
    isHeart: false,
    lastestCourse: null,
    countFavoriteCourse: {}, // Obj đến số học liệu quan tâm + yêu thích
    listCareFavoriteCourses: [], // Danh sách học liệu quan tâm + yêu thích
    // Danh sách học liệu Học Mãi
    studentCartList: [],
    registeredCourseList: [], // danh sách học liệu đã chọn để đăng ký
    relateCourseList: [], // danh sách học liệu liên quan của khóa học được chọn
    cartPriceTotal: 0, // Tổng giá giỏ học liệu
    cartPromotionPriceTotal: 0, // Tổng giá giảm giỏ học liệu
    courseComboPrice: 0, // Giá của combo học liệu
    orderStudentCartID: null, // Id đơn mua học liệu
    relatedCourseTotal: 0, // tổng số lượng học liệu liên quan
    registrationForm: {}, // đơn đắng ký học
    relatedCoursesInRegistrationForm: [], // danh sách học liệu liên quan trong đơn đăng ký học liệu
    isCourseExists: false, // học liệu đã tồn tại trong giỏ học liệu chưa
    isCheckCourseCombo: false// check item combo học liệu đính kèm có được chọn không
  },

  getters: {},

  mutations: {
    /**
     * set giá trị cho biến kiểm tra có chọn item combo học liệu không
     */
    setCourseComboPrice (state, data) {
      state.courseComboPrice = data
    },
    /**
     * set giá trị cho biến kiểm tra có chọn item combo học liệu không
     */
    setIsCheckCourseCombo (state, data) {
      state.isCheckCourseCombo = !data
    },
    /**
     * set giá trị cho biến kiểm tra học liệu đã tồn tại trong giỏ chưa
     */
    setIsCourseExists (state, data) {
      state.isCourseExists = data
    },
    /**
     * set giá trị cho đơn đăng ký
     */
    setRegistrationForm (state, data) {
      state.registrationForm = data
    },
    /**
     * set giá trị cho đơn đăng ký
     */
    setRelatedCoursesInRegistrationForm (state, data) {
      state.relatedCoursesInRegistrationForm = data
    },
    /**
     * set giá trị danh sách học liệu trong giỏ
     */
    setStudentCartList (state, data) {
      state.studentCartList = data
    },
    /**
     * set giá trị danh sách học liệu trong giỏ
     */
    setRelateCourseList (state, data) {
      if (data.length === 0) {
        state.relateCourseList = data
      } else {
        state.relateCourseList = state.relateCourseList.concat(data)
      }
    },
    /**
     * set giá trị tổng số học liên quan
     */
    setRelatedCourseTotal (state, data) {
      state.relatedCourseTotal = data
    },
    /**
     * set giá trị tổng giá giỏ học liệu
     */
    setCartPriceTotal (state, data) {
      state.cartPriceTotal = data
    },
    /**
     * set giá trị tổng giá giỏ học liệu
     */
    setCartPromotionPriceTotal (state, data) {
      state.cartPromotionPriceTotal = data
    },
    /**
     * set giá trị Id đơn mua học liệu
     */
    setOrderStudentCartID (state, data) {
      state.orderStudentCartID = data
    },
    /**
     * set giá trị danh sách học liệu đăng ký học trong giỏ
     */
    setRegisteredCourseList (state, data) {
      if (data.length === 0) {
        state.registeredCourseList = data
      } else {
        state.registeredCourseList = state.registeredCourseList.concat(data)
      }
    },
    /**
     * set list Course
     * CreateBy: VHSON 18.09
     */
    setListCourses (state, listCourseStorage) {
      state.listCourses = listCourseStorage
    },

    /**
     * set sourceId
     * CreateBy: VHSON 22.09
     */
    setSourceId (state, sourceId) {
      state.sourceId = sourceId
    },

    /**
     * set sourceLibraryId
     * CreateBy: VHSON 22.09
     */
    setSourceLibraryId (state, sourceLibraryId) {
      state.sourceLibraryId = sourceLibraryId
    },

    /**
     * Xét giá trị cho course
     * @param {*} state
     * @param {*} course
     */
    setCourse (state, course) {
      state.course = course
    },

    /**
     * Xét giá trị cho courses
     * @param {*} state
     * @param {*} courses
     */
    setCourses (state, courses) {
      state.coursesRefer = courses
    },

    /**
     * Xét giá trị cho courses
     * @param {*} state
     * @param {*} isShowCourseOverview
     */
    setIsShowCourseOverview (state, isShowCourseOverview) {
      state.isShowCourseOverview = isShowCourseOverview
    },

    /**
     * set list Course
     * CreateBy: VHSON 18.09
     */
    setTotalCount (state, totalExerciseHOCMAI) {
      state.totalExerciseHOCMAI = totalExerciseHOCMAI
    },

    /**
     * Xét giá trị
     * @param {*} state
     * @param {*} isShowUseNow
     */
    setIsShowUseNow (state, isShowUseNow) {
      state.isShowUseNow = isShowUseNow
    },

    setIsHeart (state, icHeart) {
      state.icHeart = icHeart
    },

    // Set bài tập tham khảo từ danh sách bài tập đã làm
    setLibraryExerciseRef (state, libraryExercisesRef) {
      state.libraryExercisesRef = libraryExercisesRef
    },

    // Set tổng số bản ghi bài tập tham khảo từ kho MISA
    settotalExerciseRef (state, totalExerciseRef) {
      state.totalExerciseRef = totalExerciseRef
    },

    // Set bài tập Đang học
    setLibraryLearningExercise (state, libraryLearningExercises) {
      state.libraryLearningExercises = libraryLearningExercises
    },

    // Set tổng số bản ghi bài tập đang học
    setTotalLearningExercise (state, totalLearningExercise) {
      state.totalLearningExercise = totalLearningExercise
    },

    setLastestCourse (state, data) {
      state.lastestCourse = data
    },

    // set danh sách học liệu quan tâm + yêu thích
    setlistCareFavoriteCourses (state, listCareFavoriteCourses) {
      state.listCareFavoriteCourses = listCareFavoriteCourses
    },

    // append danh sách học liệu đang học
    setAppendLearningExercises (state, appendLearningExercises) {
      state.appendLearningExercisesOld = [...appendLearningExercises]
      state.appendLearningExercises = state.appendLearningExercises.concat(state.appendLearningExercisesOld)
    },

    // Set total count danh sách  học liệu đang học
    setTotalLearningExercises (state, totalLearningExercises) {
      state.totalLearningExercises = totalLearningExercises
    },

    // Set danh sách học liệu đang học
    setLearningExercisesToEmpty (state) {
      state.appendLearningExercisesOld = []
      state.appendLearningExercises = []
    },

    // append danh sách học liệu Quan tâm
    setAppendCareExercises (state, appendCareExercises) {
      state.appendCareExercisesOld = [...appendCareExercises]
      state.appendCareExercises = state.appendCareExercises.concat(state.appendCareExercisesOld)
    },
    // Set total count danh sách học liệu Quan tâm
    setTotalCareExercises (state, totalCareExercises) {
      state.totalCareExercises = totalCareExercises
    },

    // Set danh sách học liệu quan tâm
    setCareExercisesToEmpty (state) {
      state.appendCareExercisesOld = []
      state.appendCareExercises = []
    },
    // Set số lượng học liệu quan tâm, yêu thích
    setCountFavoriteCourse (state, countFavoriteCourse) {
      state.countFavoriteCourse = countFavoriteCourse
    }

  },

  actions: {
    /**
     * @author NVThang
     * @description gọi API dữ liệu đơn đăng ký
     * @param {*} context
     * @param {*} params
     */
    async getRegistrationForm (context, params) {
      const res = await CartRegistrationFromAPI.getAsync(`/${params}`)
      if (res.IsSuccess && res.Code === HttpStatusCode.OK && res.Data) {
        context.commit('setRegistrationForm', res.Data)
      }
    },
    /**
     * Lấy danh sách theo id
     * @param {*} context
     * @param {*} param
     * @returns
     */
    getCourseById (context, param) {
      return new Promise((resolve, reject) => {
        CourseAPI.getAsync(`/${param}`)
          .then((res) => {
            context.commit('setCourse', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học liệu của học mãi
     * @author VHSon
     * @param {*} textSearch
     * @param {*} gradeID
     * @param {*} subjectID
     * @param {*} sourceType
     * @returns
     */
    getlistCourse (context, courseParams) {
      return new Promise((resolve, reject) => {
        CourseAPI.getAsync(
            `/hocmai-courses?textSearch=${courseParams.textSearch}` +
              `&gradeID=${courseParams.gradeID}` +
              `&subjectID=${courseParams.subjectID}` +
              `&takeCharge=${courseParams.takeCharge}` +
              `&pageIndex=${courseParams.pageIndex}` +
              `&pageSize=${courseParams.pageSize}`
        )
          .then((res) => {
            context.commit('setListCourses', res?.Data)
            context.commit('setTotalCount', res.Data?.Total)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách theo id và gradeID (top 3 bản ghi)
     * @param {*} context
     * @param {*} params
     * @returns
     * CreateBy: NVDuc 20.09
     */
    getFilterByCourse (context, params) {
      return new Promise((resolve, reject) => {
        CourseAPI.getAsync(`id/${params.id}?gradeID=${params.gradeID}`)
          .then((res) => {
            context.commit('setCourses', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author PVThang
     * @description Lấy thông tin course theo courseID
     */
    async getByCourseID (context, courseID) {
      if (!courseID) {
        return
      }
      const res = await CourseAPI.getAsync(`partner/${courseID}`)
      context.commit('setCourse', res?.Data)
      return res
    },

    /**
     * Lấy video giới thiệu
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getVideoIntro (context, params) {
      return new Promise((resolve, reject) => {
        CourseAPI.getAsync(`partnerID/${params}`)
          .then((res) => {
            context.commit('setVideo', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @param {*} exerciseLibrary
     * @returns
     * @author VHSON
     */
    getFilterExerciseReference (context, exerciseLibrary) {
      const query =
            `sourceType=${exerciseLibrary.sourceType}` +
            `&gradeID=${exerciseLibrary.gradeID ? exerciseLibrary.gradeID : ''}` +
            `&subjectID=${exerciseLibrary.subjectID ? exerciseLibrary.subjectID : ''}` +
            `&takeCharge=${exerciseLibrary.takeCharge ? exerciseLibrary.takeCharge : ''}` +
            `&queryText=${exerciseLibrary.queryText ? exerciseLibrary.queryText : ''}` +
            `&pageIndex=${exerciseLibrary.pageIndex ? exerciseLibrary.pageIndex : ''}` +
            `&pageSize=${exerciseLibrary.pageSize ? exerciseLibrary.pageSize : ''}`
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync('exercise-references?' + query)
          .then((res) => {
            context.commit('setLibraryExerciseRef', res.Data?.PageData)
            context.commit('settotalExerciseRef', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    async getLastestCourse (context, params) {
      const res = await PracticeCourseAPI.getAsync(`lastest-course?id=${params.studentId}&partnerId=${params.partnerId ? params.partnerId : ''}`)
      context.commit('setLastestCourse', res?.Data)
      return res
    },

    /**
     * Lấy toàn bộ thư viện học liệu đang học của học sinh
     * @param {} context
     * @returns
     * @author VHSON
     */
    getLearningExerciseOverview (context) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync('learning-overview?')
          .then((res) => {
            context.commit('setLibraryLearningExercise', res.Data?.PageData)
            context.commit('setTotalLearningExercise', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @returns
     * @author VHSON
     */
    getLearningExerciseTab (context, params) {
      const query =
      `sourceLibrary=${params.sourceLibrary}` +
      `&subjectID=${params.subjectID ? params.subjectID : ''}` +
      `&queryText=${params.queryText ? params.queryText : ''}` +
      `&pageIndex=${params.pageIndex ? params.pageIndex : ''}` +
      `&pageSize=${params.pageSize ? params.pageSize : ''}`
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync('learning-tab?' + query)
          .then((res) => {
            context.commit('setAppendLearningExercises', res.Data?.PageData)
            context.commit('setTotalLearningExercises', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @returns
     * @author VHSON
     */
    getCountPracticeFavorite (context) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync('count-care-favorite')
          .then((res) => {
            context.commit('setCountFavoriteCourse', res.Data)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @returns
     * @author VHSON
     */
    getCareExerciseTab (context, params) {
      const query =
      `status=${params.status}` +
      `&subjectCode=${params.subjectCode ? params.subjectCode : ''}` +
      `&queryText=${params.queryText ? params.queryText : ''}` +
      `&pageIndex=${params.pageIndex ? params.pageIndex : ''}` +
      `&pageSize=${params.pageSize ? params.pageSize : ''}`
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync('course-care-list?' + query)
          .then((res) => {
            context.commit('setAppendCareExercises', res.Data?.PageData)
            context.commit('setTotalCareExercises', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học liệu củng cố kiến thức và luyện tập
     * @author VHSon
     * @returns
     */
    getlistSourceCareAndFavoriteForOverview (context) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync('/course-care-favourite')
          .then((res) => {
            context.commit('setlistCareFavoriteCourses', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy thông tin giỏ học liệu
     * @author TTLONG
     */
    getStudentCartList (context) {
      return new Promise((resolve, reject) => {
        StudentCartAPI.getAsync('/carts')
          .then((res) => {
            if (res?.Data) {
              const data = res?.Data.map(item => {
                const listCourse = item.ListCourse.map(course => {
                  switch (course.SourceType) {
                    case enumeration.SourceTypeCourse.HOCMAI:
                      if (item.GradeID < 6) {
                        course.Price = Data.HocMaiCoursePrice.PrimarySchool
                      } else if (item.GradeID < 10) {
                        course.Price = Data.HocMaiCoursePrice.SecondarySchool
                      } else {
                        course.Price = Data.HocMaiCoursePrice.HighSchool
                      }
                      return course
                    case enumeration.SourceTypeCourse.CONTUHOC:
                      // Không cần xử lý gì do đã xét giá khi thêm vào giỏ hàng
                      return course
                  }
                })
                item.ListCourse = listCourse
                return item
              })
              context.commit('setStudentCartList', data)
            }
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Thêm thông tin giỏ học liệu
     * @author TTLONG
     */
    insertStudentCart (context, param) {
      return new Promise((resolve, reject) => {
        StudentCartAPI.postAsync('/course', param)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Cập nhật thông tin giỏ học liệu
     * @author TTLONG
     */
    updateStudentCart (context, param) {
      return new Promise((resolve, reject) => {
        StudentCartAPI.getAsync('/course', param)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
       * Xóa học liệu trong giỏ
       * @author TTLONG
       */
    deleteStudentCart (context, courseID) {
      return new Promise((resolve, reject) => {
        StudentCartAPI.deleteAsync(`/course?id=${courseID}`)
          .then((res) => {
            if (res?.Data) {
              context.commit('setRelateCourseList', [])
              context.commit('setStudentCartList', [])
            }

            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * lấy học liệu liên quan
     */
    getRelateCourses (context, params) {
      return new Promise((resolve, reject) => {
        ELKCourseAPI.getAsync('/list-exercise-parnets', { params: params })
          .then((res) => {
            if (res?.Data?.PageData?.length > 0) {
              const data = res?.Data.PageData.map(item => {
                item.CourseID = item.Id
                item.CourseName = item.Name
                if (params.gradeID < 6) {
                  item.Price = Data.HocMaiCoursePrice.PrimarySchool
                } else if (params.gradeID < 10) {
                  item.Price = Data.HocMaiCoursePrice.SecondarySchool
                } else {
                  item.Price = Data.HocMaiCoursePrice.HighSchool
                }
                return item
              })
              context.commit('setRelateCourseList', data)
              context.commit('setRelatedCourseTotal', res?.Data.Total)
            }

            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * lấy học liệu liên quan
     */
    getRelatedCourseList (context, params) {
      return new Promise((resolve, reject) => {
        ELKCourseAPI.getAsync('/exercise-reference', { params: params })
          .then((res) => {
            if (res?.Data?.PageData?.length > 0) {
              const data = res?.Data?.PageData?.map(item => {
                item.CourseID = item.Id
                item.CourseName = item.Name
                item.IsChecked = false
                if (params.gradeID < 6) {
                  item.Price = Data.HocMaiCoursePrice.PrimarySchool
                } else if (params.gradeID < 10) {
                  item.Price = Data.HocMaiCoursePrice.SecondarySchool
                } else {
                  item.Price = Data.HocMaiCoursePrice.HighSchool
                }
                return item
              })

              context.commit('setRelateCourseList', data)
              context.commit('setRelatedCourseTotal', res?.Data.Total)
            }

            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * thêm dữ liệu vào Order học liệu Học Mãi
     */
    orderStudentCart (context, params) {
      return new Promise((resolve, reject) => {
        CartRegistrationFromAPI.postAsync('/order', params)
          .then((res) => {
            // localStorage.set(localStorageKeys.ORDER_STUDENTCART_ID, res.Data)
            context.commit('setOrderStudentCartID', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
